import {
  ObjectEx
} from "vue-objectex";
import {
  runObjectExtender
} from "vue-js-extender";
runObjectExtender();

import { hubHandler } from "@/script/hubHandler.js"

const roleType = {
  admin: { id: 1, name: "1", label: "管理员" },
  student: { id: 2, name: "2", label: "学生" },
  teacher: { id: 3, name: "3", label: "老师" },
  sales: { id: 4, name: "4", label: "行政销售" },
  assistant: { id: 5, name: "5", label: "行政助理" },
  financialManager: { id: 6, name: "6", label: "财务主管" },
  executiveManager: { id: 7, name: "7", label: "行政管理" },
  educationalAssistant: { id: 8, name: "8", label: "教务助理" },
  financialAssistant: { id: 9, name: "9", label: "财务助理" }
};

const loginType = {
  student: { name: "学生" },
  speedup: { name: "速成人员" }
};

const bonusPointMechanismType = {
  moneyToBonusPoint: 1,
  bonusPointToMoney: 2
};

const globalPriceType = {
  universityTutoringPrice: 1,
  normalVideoPrice: 2,
  supplementVideoPrice: 3,
  membershipCardPrice: 4,
  paymentCommissionRate: 5,
  advanceEnrollmentPrice: 6,
  renewMembershipCardPrice: 7,
  academicPlanningOnce: 8,
  academicPlanningUnlimited: 9,
  trainingAdvanceEnrollmentPrice : 10,
  renewMembershipCardPriceDiscount : 11,
  afterDiscountMembershipCardPrice:12,
};

const formulaType = {
  none: 0,
  discount: 1,
  systemVariable: 2,
  customVariable: 3
};

const accountType = {
  none: 0,
  advanceEnrollment: 1,
  signClass: 2,
  memberCard: 3,
  renewMemberCard: 4,
  watchVideos: 5,
  bonusPointExchangeItem: 6,
  academicPlanning: 7,
  trainingAdvanceEnrollment : 8,
  trainingSignClass : 9,
  englishSignClass : 10,
};

const contractType = {
  none: 0,
  advanceEnrollment: 1,
  universityCourse: 2,
  englishCourse: 3,
  vocationalTraining: 4
};

const otherCollectFeeType = {
  memberCard: { value: 1, description: "会员卡" },
  renewMemberCard: { value: 2, description: "补办会员卡" },
  watchVideos: { value: 3, description: "看视频" },
  bonusPointExchangeItem: { value: 4, description: "积分兑换物品" },
  academicPlanning: { value: 5, description: "学业规划" }
};

const courseType = {
  none: { value: 0, description: "" },
  university: { value: 1, description: "大学补习" },
  english: { value: 2, description: "应试英语" },
  vocationalTraining: { value: 3, description: "职业培训" }
};

const checkDevice = false;
const bypassVideoAppointment = true;
const wechatEnable = true;
const browserBrand = null;

const enumQuestionnaireQuestionType = new ObjectEx([{
  key: "Unknown",
  value: 0,
  desc: "未知"
}, {
  key: "Choice",
  value: 1,
  desc: "选择"
}, {
  key: "ShortAnswer",
  value: 2,
  desc: "简答"
}, {
  key: "Rate",
  value: 3,
  desc: "评分"
}], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", String.empty);
  }
}, {
  selectListItems: {
    get() {
      let options = this.getOptions().filter(item => item.value !== 0);

      return options.map(item => ({
        value: item.value,
        label: item.desc
      }));
    }
  }
});

const enumQuestionnaireValueType = new ObjectEx([{
  key: "String",
  value: 0,
  desc: "String"
}, {
  key: "Int32",
  value: 1,
  desc: "Int32"
}], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", String.empty);
  }
}, {
  selectListItems: {
    get() {
      let options = this.getOptions();

      return options.map(item => ({
        value: item.value,
        label: item.desc
      }));
    }
  }
});

export default Object.deepFreeze({
  roleType, //角色
  loginType, //登陆入口
  bonusPointMechanismType, //积分机制类型
  globalPriceType, //价格类型,
  formulaType, //公式类型
  accountType, //账目类型
  contractType, //合同类型
  otherCollectFeeType, //其他收费类型
  courseType, //课程类型
  bypassVideoAppointment,
  checkDevice,
  wechatEnable,
  hubHandler: new hubHandler(),
  enumQuestionnaireQuestionType,
  enumQuestionnaireValueType
});



// WEBPACK FOOTER //
// ./src/core/global.js